import { Box, Typography, createStyles, makeStyles } from '@material-ui/core';
import { PinDropRounded } from '@material-ui/icons';
import React from 'react';
var useStyle = makeStyles(function (theme) {
    return createStyles({
        distance: {
            color: theme.palette.grey[400],
            display: 'flex',
            fontSize: theme.typography.body2.fontSize,
            lineHeight: 1,
        },
    });
});
export default (function (_a) {
    var distance = _a.distance;
    var styles = useStyle({});
    return (React.createElement(Box, { display: "flex", alignItems: "start" },
        React.createElement(PinDropRounded, { className: styles.distance }),
        React.createElement(Typography, { className: styles.distance },
            distance,
            "m")));
});
//# sourceMappingURL=index.js.map